import React, { useCallback } from 'react';
import styled from 'styled-components';

const StyledLink = styled.a`
    width: 100%;
    text-align: center;
    background-color: var(--sm-brand-bg);
    color: var(--sm-footer-text);
    text-transform: uppercase;
    display: inline-block;
    text-decoration: none;
    padding: 10px 0;
    font-size: 1rem;
    &:hover,
    &:active,
    &:focus {
        color: #fff;
    }
`;

export function TopLink() {
    const scrollTop = useCallback((e) => {
        e.preventDefault();
        try {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        } catch (error) {
            window.scrollTo(0, 0);
        }
    }, []);
    return (
        <StyledLink href="#" type="button" onClick={scrollTop}>
            Back to top
        </StyledLink>
    );
}
